<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：アラーム一覧画面
 *
 * 作成者：2022/1/29 ノア）黄
 * 最終修正者：2022/1/29 ノア）黄
 *
 -->
<template>
  <div class="tti-main-view">
    <!-- ヘッダー -->
    <section>
      <nav class="tti-main-header-shadow">
        <div class="pull-left pos-rel">
          <el-button class="backButton" icon="el-icon-back"></el-button>
          <span class="tti-viewTitle">アラーム一覧</span>
        </div>
      </nav>
    </section>
    <!-- テーブル -->
    <section class="tti-padding-content">
      <el-collapse v-model="active">
        <el-collapse-item title="検索条件" name="1">
          <el-form :model="form" class="form" label-width="120px">
            <el-form-item prop="type" label="種類">
              <el-radio-group v-model="form.type">
                <el-radio label="0">会社</el-radio>
                <el-radio label="1">営業所</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="period" label="期間">
              <el-date-picker
                v-model="form.period"
                type="monthrange"
                range-separator="〜"
                start-placeholder="開始月"
                end-placeholder="終了月"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="target" label="絞り込み条件">
              <el-radio-group v-model="form.target">
                <el-radio label="0">すべて</el-radio>
                <el-radio label="1">受信回数が超える対象のみ</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button class="tti-btn-default" @click="onSearchClick">検索</el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </section>
    <!-- テーブル -->
    <section class="tti-padding-content">
      <!-- TODO height -->
      <el-table
        :data="alarmData"
        height="calc(100vh - 170px)"
        border
        header-row-class-name="tti-master-table-header"
        :empty-text="$t('messages.common.emptyTableData')"
      >
        <!-- 営業所名 -->
        <el-table-column prop="businessOfficeName" label="営業所名" align="left" width="200" :sortable="false">
        </el-table-column>
        <!-- 利用開始日 -->
        <el-table-column prop="applicationStartDate" label="利用開始日" align="left" width="200" :sortable="false">
        </el-table-column>
        <!-- SigfoxID -->
        <el-table-column prop="sigfoxId" label="SigfoxID" align="left" width="200" :sortable="false"> </el-table-column>
        <!-- 管理対象名 -->
        <el-table-column prop="managementTargetName" label="管理対象名" align="left" width="200" :sortable="false">
        </el-table-column>
        <!-- 詳細 -->
        <template v-if="alarmData && alarmData.length > 0">
          <template v-for="(operating, index) in alarmData[0].operatingDetail">
            <el-table-column width="100" :sortable="true" :key="index" :label="operating.date" align="right">
              <template slot-scope="scope">
                <span :class="{ redBackgroundColor: index === 0 }">{{
                  alarmData[scope.$index].operatingDetail[index].operatingDate
                }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
        <el-table-column prop="count" label="期間合計" align="right"> </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Component, Vue } from 'vue-property-decorator'

import { getAlarmData } from '@/store/apis'

/**
 * アラーム一覧画面
 *
 * @class
 */
@Component({
  name: 'alarm'
})
export default class ALARM extends Vue {
  /**
   * アラーム一覧
   */
  alarmData = [] as {
    businessOfficeName: string
    applicationStartDate: string
    sigfoxId: string
    managementTargetName: string
    operatingDetail: {
      date: string
      operatingDate: string
    }[]
    count: number
  }[]

  form = {
    type: '0',
    period: ['2021/1', '2021/11'],
    target: '0'
  }

  active = '1'

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    this.$log.debug('ALARM > mounted')
  }

  /**
   * アラーム一覧を取得する
   *
   * @returns {void}
   */
  async fetchAlarmData(): Promise<void> {
    try {
      const data = await getAlarmData()
      this.alarmData = data.list
    } catch (e) {
      this.$log.debug('MGMT_TRGTS > fetchAlarmData: e=', e)
      throw e
    }
  }

  onSearchClick(): void {
    this.$log.debug('ALARM > onSearchClick', this.form)
    this.fetchAlarmData()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cell {
  text-overflow: unset;
}

::v-deep .tti-bottom-right-area .tti-btn-default {
  margin-right: 0 !important;
}

.redBackgroundColor {
  background-color: $C23;
  width: 100%;
  display: block;
}

.yellowBackgroundColor {
  background-color: $C24;
}

.pos-rel {
  position: relative;

  .notes-title {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

.form {
  padding: 20px;
}

::v-deep .el-collapse-item__header {
  padding-left: 10px;
  font-weight: bold;
  border-bottom: 1px solid rgb(212, 212, 212);
}
</style>
